var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealjob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 207,
    viewBox: "0 0 444 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.109 69.6033H141C139.128 69.6033 137.76 67.8342 138.232 66.0228L154.859 2.14021C155.187 0.879993 156.325 0 157.627 0H335.736C337.608 0 338.975 1.76912 338.504 3.58058L321.877 67.4631C321.549 68.7234 320.411 69.6033 319.109 69.6033Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.428 13.668H227.403",
    stroke: "#A9C2FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.66 42.2734H222.636",
    stroke: "#A9C2FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.721 31.4648H248.698",
    stroke: "#A9C2FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.838 23.2031H182.431",
    stroke: "#A9C2FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.296 31.4648H179.889",
    stroke: "#A9C2FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.255 13.668H259.345",
    stroke: "#A9C2FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.079 55.6916H215.095C214.928 55.6916 214.807 55.5347 214.849 55.3736L216.325 49.7018C216.354 49.5898 216.455 49.5117 216.571 49.5117H249.555C249.721 49.5117 249.843 49.6686 249.801 49.8297L248.325 55.5015C248.296 55.6136 248.195 55.6916 248.079 55.6916Z",
    stroke: "#84AEE5",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.08 55.6916H174.095C173.929 55.6916 173.808 55.5347 173.85 55.3736L175.326 49.7018C175.355 49.5898 175.456 49.5117 175.571 49.5117H208.556C208.722 49.5117 208.843 49.6686 208.802 49.8297L207.326 55.5015C207.297 55.6136 207.196 55.6916 207.08 55.6916Z",
    stroke: "#84AEE5",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.053 47.4692C304.362 45.2169 297.502 43.5789 295.607 41.3275C294.639 40.1768 294.639 38.0391 294.87 36.2218C295.545 35.7918 296.105 35.3601 296.439 34.9591C297.009 34.1273 297.651 32.9642 298.294 31.6882C298.488 31.8783 298.748 32.0269 299.083 32.017C299.983 31.9904 303.412 27.324 302.528 26.2422C302.022 25.6237 301.206 26.16 300.599 26.7329C301.506 24.6549 302.145 23.0618 302.145 23.0618H302.11C302.196 22.7995 302.275 22.5363 302.342 22.269C303.702 16.813 300.383 12.3906 294.927 12.3906C289.472 12.3906 283.946 16.813 282.587 22.269C282.52 22.5363 282.468 22.8003 282.423 23.0618H282.388C282.388 23.0618 282.232 24.6549 282.103 26.7329C281.782 26.16 281.233 25.6237 280.42 26.2422C278.996 27.324 280.098 31.9904 280.985 32.017C281.316 32.0269 281.649 31.8783 281.938 31.6882C281.946 32.9642 282.008 34.1273 282.162 34.9591C282.326 35.449 282.804 35.9852 283.426 36.5091C282.747 38.2599 281.713 40.2374 280.252 41.3275C277.234 43.5798 269.558 45.2169 266.744 47.4692C264.214 49.4948 261.956 55.4107 261.527 56.5796H306.726C306.881 55.4107 307.573 49.4948 306.053 47.4692Z",
    fill: "#8DBCF8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.122 120.459H110.012C108.14 120.459 106.773 118.69 107.244 116.878L123.871 52.9957C124.199 51.7355 125.337 50.8555 126.639 50.8555H304.748C306.62 50.8555 307.987 52.6246 307.516 54.436L290.889 118.319C290.561 119.579 289.423 120.459 288.122 120.459Z",
    stroke: "#7094D8",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M284.784 115.689H106.675C104.803 115.689 103.436 113.92 103.907 112.109L120.534 48.2262C120.862 46.9659 122 46.0859 123.302 46.0859H301.411C303.283 46.0859 304.651 47.8551 304.18 49.6665L287.553 113.549C287.224 114.81 286.086 115.689 284.784 115.689Z",
    fill: "#A5C5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.567 115.688H251.717",
    stroke: "#7094D8",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.777 46.0859H213.101",
    stroke: "#7094D8",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M270.404 106.151H230.359C228.516 106.151 227.394 104.656 227.854 102.813L237.957 62.2905C238.417 60.4475 240.284 58.9531 242.127 58.9531H282.172C284.015 58.9531 285.137 60.4475 284.677 62.2905L274.573 102.813C274.114 104.656 272.247 106.151 270.404 106.151Z",
    fill: "#B7DEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250.751 106.312L254.256 92.2567L248.51 89.8242C248.51 89.8242 237.802 93.7435 236.891 94.6899C236.126 95.4828 232.282 103.682 231.058 106.312H250.751Z",
    fill: "#023F61"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M270.58 106.312C270.669 103.682 270.912 95.4828 270.543 94.6899C270.103 93.7435 261.35 89.8242 261.35 89.8242L254.391 92.2567L250.887 106.312H270.58Z",
    fill: "#023F61"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M254.376 106.308L259.865 94.1445L248.074 94.8203L246.921 106.308H254.376Z",
    fill: "#BEBECF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250.637 87.2553L248.07 88.8775L246.384 92.9321L245.948 98.4727L249.562 96.9867L252.368 100.365L256.117 97.2565L258.416 99.4191L261.891 91.9857L261.28 87.3906L259.827 86.7148L250.637 87.2553Z",
    fill: "#DEE0E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M251.426 76.6192C251.426 76.6192 250.564 74.6592 248.795 75.9634C247.027 77.2668 249.097 82.3018 250.378 80.7867C251.659 79.2716 251.426 76.6192 251.426 76.6192Z",
    fill: "#FB8E74"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M264.028 76.5135C264.028 76.5135 265.708 74.4364 266.976 75.6003C268.244 76.7642 264.076 82.0857 263.391 80.6619C262.706 79.2382 264.028 76.5135 264.028 76.5135Z",
    fill: "#FB8E74"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M260.088 91.1812L261.897 81.5859L251.428 82.4933L249.117 91.505C249.117 91.505 250.947 95.7704 252.908 97.6624C252.908 97.6624 258.997 92.4032 260.088 91.1812Z",
    fill: "#FB8877"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M268.579 72.6395C268.189 73.8068 267.227 74.0982 267.156 74.7789C267.085 75.4597 266.648 77.2097 265.984 77.8904C265.32 78.5712 264.976 78.7655 264.976 78.7655C264.976 78.7655 255.993 81.2942 251.432 77.7925C251.432 77.7925 251.133 76.4633 251.446 74.8752C251.756 73.3028 250.993 73.0272 251.879 72.2493C252.764 71.4715 253.033 70.7907 253.053 69.9157C253.074 69.0407 253.143 67.9706 254.053 67.0956C254.963 66.2206 255.779 66.5119 256.665 65.7341C256.665 65.7341 257.975 63.5349 259.705 63.285C261.435 63.0351 265.083 62.1178 267.252 64.786C269.422 67.4542 268.422 69.7895 269.048 70.623C269.676 71.4582 268.579 72.6395 268.579 72.6395Z",
    fill: "#713336"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M251.356 74.9697C251.356 74.9697 247.118 86.6445 255.1 87.5195C262.153 87.6831 264.658 79.0758 265.667 74.6617C266.677 70.2476 266.053 65.626 260.407 65.777C254.761 65.9281 251.977 72.3546 251.356 74.9697Z",
    fill: "#FBA990"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M253.572 70.7786C253.572 70.7786 254.095 71.7142 253.611 72.6581C253.127 73.602 251.813 73.9648 251.617 75.2101C251.42 76.4553 250.844 79.0455 250.491 79.1584C250.138 79.2722 250.388 76.6297 250.447 75.724C250.507 74.8182 251.182 71.0733 253.064 68.6948C254.947 66.3163 256.11 65.3118 259.463 64.7664C262.814 64.2209 265.355 65.6314 266.288 67.677C267.221 69.7226 265.728 74.932 265.728 74.932C265.728 74.932 265.951 72.4555 265.122 71.8752C264.293 71.2941 263.607 70.8641 263.745 70.5245C263.882 70.185 261.091 71.4161 258.303 70.5195C255.513 69.6229 254.612 70.0306 254.148 70.3178C253.684 70.6042 253.572 70.7786 253.572 70.7786Z",
    fill: "#713336"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M245.674 93.0664C245.607 93.337 241.778 102.459 241.778 102.459L245.141 104.149L244.196 106.041",
    stroke: "#022755",
    strokeWidth: 0.4884,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M262.23 93.0664C262.163 93.337 261.443 102.459 261.443 102.459L257.237 104.149L257.238 106.041",
    stroke: "#022755",
    strokeWidth: 0.4884,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M270.404 106.155H230.359C228.516 106.155 227.394 104.66 227.854 102.817L237.957 62.2944C238.417 60.4514 240.284 58.957 242.127 58.957H282.172C284.015 58.957 285.137 60.4514 284.677 62.2944L274.573 102.817C274.114 104.66 272.247 106.155 270.404 106.155Z",
    stroke: "white",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M131.102 61.3398H193.078",
    stroke: "#73A5FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M126.335 89.9453H188.311",
    stroke: "#73A5FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152.397 79.1406H214.372",
    stroke: "#73A5FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M129.513 70.875H148.106",
    stroke: "#73A5FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M126.97 79.1406H145.563",
    stroke: "#73A5FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M202.931 61.3398H225.019",
    stroke: "#73A5FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M213.755 103.363H180.77C180.604 103.363 180.483 103.207 180.524 103.046L182 97.3737C182.029 97.2616 182.13 97.1836 182.246 97.1836H215.231C215.397 97.1836 215.518 97.3405 215.476 97.5016L214 103.173C213.971 103.285 213.87 103.363 213.755 103.363Z",
    stroke: "#7094D8",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M172.755 103.363H139.77C139.604 103.363 139.483 103.207 139.525 103.046L141.001 97.3737C141.03 97.2616 141.131 97.1836 141.246 97.1836H174.231C174.397 97.1836 174.518 97.3405 174.477 97.5016L173.001 103.173C172.972 103.285 172.871 103.363 172.755 103.363Z",
    stroke: "#7094D8",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M210.718 38.9336H249.333",
    stroke: "#7094D8",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M286.691 206.904H108.582C106.71 206.904 105.342 205.135 105.814 203.324L122.441 139.441C122.769 138.181 123.907 137.301 125.209 137.301H303.318C305.19 137.301 306.557 139.07 306.086 140.881L289.459 204.764C289.131 206.025 287.993 206.904 286.691 206.904Z",
    fill: "#BFD9FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M133.009 150.965H194.985",
    stroke: "#A9C2FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M128.242 179.566H190.218",
    stroke: "#A9C2FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M154.303 168.762H216.279",
    stroke: "#A9C2FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M131.42 160.5H150.013",
    stroke: "#A9C2FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M128.877 168.762H147.47",
    stroke: "#A9C2FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M204.837 150.965H226.926",
    stroke: "#A9C2FF",
    strokeWidth: 3.4455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M215.661 192.988H182.676C182.51 192.988 182.389 192.832 182.431 192.671L183.907 186.999C183.936 186.887 184.037 186.809 184.152 186.809H217.137C217.303 186.809 217.424 186.965 217.383 187.127L215.907 192.798C215.878 192.91 215.777 192.988 215.661 192.988Z",
    stroke: "#84AEE5",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M174.662 192.988H141.677C141.511 192.988 141.389 192.832 141.431 192.671L142.907 186.999C142.936 186.887 143.038 186.809 143.153 186.809H176.138C176.304 186.809 176.425 186.965 176.384 187.127L174.908 192.798C174.879 192.91 174.777 192.988 174.662 192.988Z",
    stroke: "#84AEE5",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M273.635 184.765C271.944 182.513 265.085 180.875 263.189 178.624C262.221 177.473 262.221 175.335 262.452 173.518C263.127 173.088 263.687 172.656 264.021 172.255C264.591 171.423 265.233 170.26 265.876 168.984C266.07 169.174 266.33 169.323 266.665 169.313C267.565 169.286 270.994 164.619 270.11 163.538C269.604 162.92 268.788 163.456 268.181 164.029C269.088 161.951 269.727 160.358 269.727 160.358H269.692C269.778 160.095 269.857 159.832 269.924 159.565C271.284 154.11 267.965 149.688 262.509 149.688C257.054 149.688 251.528 154.11 250.169 159.565C250.102 159.832 250.05 160.096 250.005 160.358H249.97C249.97 160.358 249.814 161.951 249.685 164.029C249.364 163.456 248.815 162.92 248.002 163.538C246.578 164.62 247.68 169.286 248.567 169.313C248.898 169.323 249.231 169.174 249.52 168.984C249.528 170.26 249.59 171.423 249.744 172.255C249.908 172.745 250.386 173.281 251.008 173.805C250.329 175.556 249.295 177.533 247.834 178.624C244.816 180.876 237.14 182.514 234.326 184.765C231.796 186.791 229.538 192.707 229.109 193.876H274.308C274.463 192.706 275.155 186.791 273.635 184.765Z",
    fill: "#8DBCF8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.587 207.219H200.229",
    stroke: "#7094D8",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M217.551 207.219H235.984",
    stroke: "#7094D8",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M297.165 137.617H303.554C305.433 137.617 306.776 139.435 306.223 141.231L303.521 150.013",
    stroke: "#7094D8",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8027 25.2856H91.5435C90.7249 25.2856 90.2276 24.6222 90.431 23.8037L91.2438 20.5444C91.448 19.7258 92.2765 19.0625 93.0951 19.0625H96.3544C97.1729 19.0625 97.6702 19.7258 97.4668 20.5444L96.6541 23.8037C96.4498 24.6222 95.6213 25.2856 94.8027 25.2856Z",
    fill: "#BFD9FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4199 34.8481H89.1607C88.3421 34.8481 87.8448 34.1847 88.0482 33.3662L88.861 30.1069C89.0652 29.2883 89.8937 28.625 90.7123 28.625H93.9716C94.7901 28.625 95.2874 29.2883 95.084 30.1069L94.2713 33.3662C94.067 34.1847 93.2385 34.8481 92.4199 34.8481Z",
    fill: "#EDF4FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M102.791 34.8481H99.532C98.7134 34.8481 98.2161 34.1847 98.4195 33.3662L99.2323 30.1069C99.4365 29.2883 100.265 28.625 101.084 28.625H104.343C105.161 28.625 105.659 29.2883 105.455 30.1069L104.643 33.3662C104.438 34.1847 103.61 34.8481 102.791 34.8481Z",
    fill: "#BFD9FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M113.162 34.8481H109.903C109.084 34.8481 108.587 34.1847 108.79 33.3662L109.603 30.1069C109.807 29.2883 110.636 28.625 111.454 28.625H114.714C115.532 28.625 116.03 29.2883 115.826 30.1069L115.013 33.3662C114.809 34.1847 113.981 34.8481 113.162 34.8481Z",
    fill: "#EDF4FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9824 44.6215H86.7231C85.9046 44.6215 85.4073 43.9582 85.6107 43.1396L86.4234 39.8803C86.6277 39.0618 87.4562 38.3984 88.2748 38.3984H91.5341C92.3526 38.3984 92.8499 39.0618 92.6465 39.8803L91.8337 43.1396C91.6295 43.9582 90.8002 44.6215 89.9824 44.6215Z",
    fill: "#EDF4FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3782 55.0668H84.1189C83.3003 55.0668 82.8031 54.4035 83.0065 53.5849L83.8192 50.3256C84.0234 49.5071 84.8519 48.8438 85.6705 48.8438H88.9298C89.7484 48.8438 90.2457 49.5071 90.0423 50.3256L89.2295 53.5849C89.0253 54.4035 88.1959 55.0668 87.3782 55.0668Z",
    fill: "#EDF4FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M100.353 44.6215H97.0938C96.2752 44.6215 95.7771 43.9582 95.9813 43.1396L96.7941 39.8803C96.9983 39.0618 97.8268 38.3984 98.6454 38.3984H101.905C102.723 38.3984 103.221 39.0618 103.017 39.8803L102.204 43.1396C102 43.9582 101.172 44.6215 100.353 44.6215Z",
    fill: "#EDF4FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8093 62.8441H92.55C91.7315 62.8441 91.2342 62.1808 91.4376 61.3623L92.2503 58.103C92.4546 57.2844 93.2831 56.6211 94.1017 56.6211H97.361C98.1795 56.6211 98.6768 57.2844 98.4734 58.103L97.6607 61.3623C97.4564 62.1808 96.6279 62.8441 95.8093 62.8441Z",
    fill: "#BFD9FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M147.081 6.32632V6.32466C147.065 6.32383 147.049 6.323 147.032 6.32217C146.983 6.31885 146.935 6.31221 146.884 6.30972L146.883 6.31387C146.548 6.29312 146.209 6.27734 145.863 6.27734C136.199 6.27734 126.417 14.0254 123.842 23.6481L123.728 24.108H123.723C123.711 24.1562 123.703 24.2035 123.691 24.2516L123.618 24.5463H123.628C121.507 34.2993 127.765 42.0624 137.784 41.6572C146.92 41.287 156.134 33.9955 158.876 24.9581C161.85 15.1561 156.438 6.98051 147.081 6.32632ZM153.747 24.626C151.818 31.0508 145.233 36.2378 138.751 36.4437C131.783 36.6645 127.435 31.2567 128.872 24.4559L129.073 23.6481H129.066C130.919 16.9095 137.781 11.5 144.561 11.5C144.912 11.5 145.254 11.5183 145.591 11.5473C152.068 12.0944 155.797 17.7953 153.747 24.626Z",
    fill: "#EBEDFC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M146.129 9.33993C145.83 10.5412 146.391 11.5839 147.484 11.8736C152.768 13.2717 155.588 18.4952 153.746 24.6294C151.818 31.0542 145.232 36.2403 138.751 36.4462C132.395 36.648 128.216 32.1683 128.62 26.2192C128.704 24.9914 127.832 24.1114 126.584 24.1114C124.966 24.1114 123.355 25.5708 123.247 27.1623C122.673 35.6509 128.677 42.0292 137.784 41.6606C146.921 41.2903 156.134 33.9988 158.876 24.9615C161.523 16.2371 157.527 8.79782 150.019 6.80621C148.468 6.39361 146.555 7.63556 146.129 9.33993Z",
    fill: "#A5C5FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M191.101 4.53336L191.102 4.5317C191.086 4.53087 191.071 4.53004 191.056 4.52921C190.994 4.52505 190.932 4.52256 190.871 4.51841C190.546 4.49849 190.219 4.48438 189.884 4.48438C180.11 4.48438 170.21 12.4076 167.773 22.1822C165.337 31.956 171.284 39.8801 181.059 39.8801C181.392 39.8801 181.726 39.8659 182.06 39.846C182.123 39.8427 182.185 39.8394 182.248 39.836C182.266 39.8352 182.283 39.8344 182.301 39.8327V39.8311C191.606 39.2026 200.73 31.6255 203.126 22.3366C203.139 22.2852 203.155 22.2345 203.168 22.183C205.503 12.8219 200.143 5.16513 191.101 4.53336ZM183.24 34.6225C183.223 34.6233 183.207 34.625 183.191 34.6258C182.985 34.6391 182.779 34.6474 182.573 34.6516C182.502 34.6524 182.431 34.6565 182.36 34.6565C175.471 34.6565 171.278 29.0711 172.996 22.1814C174.714 15.2917 181.691 9.70623 188.581 9.70623C188.652 9.70623 188.72 9.71038 188.79 9.71121C188.995 9.71453 189.198 9.72366 189.398 9.73694C189.415 9.73777 189.432 9.73943 189.449 9.74109C195.817 10.1919 199.589 15.5872 197.945 22.1814C197.931 22.2329 197.916 22.2835 197.902 22.335C196.197 28.8627 189.782 34.1792 183.24 34.6225Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M197.143 24.5152C194.949 29.5178 190.033 33.4629 184.795 34.4276C183.488 34.6683 182.304 35.7293 181.987 36.9995C181.577 38.6441 182.771 39.8702 184.464 39.5631C191.928 38.2074 198.943 32.5796 202.052 25.4441C202.755 23.8311 201.902 22.3359 200.261 22.3359C198.986 22.3359 197.693 23.2616 197.143 24.5152Z",
    fill: "#BFD9FF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M144.151 66.8127H111.167C111 66.8127 110.878 66.6558 110.921 66.4947L112.397 60.8229C112.426 60.7108 112.527 60.6328 112.643 60.6328H145.627C145.793 60.6328 145.915 60.7897 145.873 60.9508L144.397 66.6226C144.368 66.7347 144.267 66.8127 144.151 66.8127Z",
    fill: "#EDF4FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M297.154 93.1383C304.019 87.076 305.752 77.8213 301.025 72.4673C296.297 67.1133 286.899 67.6875 280.033 73.7498C273.168 79.8121 271.435 89.0668 276.162 94.4208C280.89 99.7748 290.288 99.2006 297.154 93.1383Z",
    fill: "#73A5FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M310.232 99.1605C309.68 101.374 307.438 103.169 305.224 103.169C303.011 103.169 301.664 101.375 302.216 99.1605C302.768 96.9472 305.009 95.1523 307.223 95.1523C309.437 95.1523 310.784 96.9464 310.232 99.1605Z",
    fill: "#73A5FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M284.808 90.8737C284.348 90.8737 283.931 90.6977 283.667 90.3465L279.882 85.3048C279.354 84.6016 279.638 83.4618 280.517 82.7586C281.396 82.0555 282.535 82.0555 283.063 82.7586L285.892 86.5268L295.999 78.4375C296.877 77.7344 298.017 77.7344 298.545 78.4375C299.073 79.1407 298.789 80.2805 297.91 80.9837L286.213 90.3465C285.774 90.6977 285.269 90.8737 284.808 90.8737Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M383.931 54.3594C383.931 54.3594 382.342 57.5373 381.388 64.5299C380.435 71.5217 382.977 111.886 382.977 111.886L410.31 109.026L397.915 56.2671L383.931 54.3594Z",
    fill: "#024470"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M337.312 95.74L320.882 92.5039C320.882 92.5039 320.633 94.7446 322.126 95.2427C323.62 95.7408 323.62 95.7408 323.62 95.7408C323.62 95.7408 327.354 104.703 329.096 105.699C330.839 106.694 341.298 111.01 341.298 111.01L344.033 100.471L337.312 95.74Z",
    fill: "#FF7759"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M349.129 109.03C349.129 109.03 348.971 107.918 346.773 103.46C344.335 98.5176 343.786 96.4895 343.786 96.4895C343.786 96.4895 336.068 93.5025 334.824 92.0082C333.579 90.5147 332.832 90.2656 332.832 90.2656C332.832 90.2656 331.339 93.0036 333.579 94.9952C335.82 96.9868 337.812 98.4803 337.812 98.4803C337.812 98.4803 337.562 104.206 338.31 106.945C339.057 109.684 341.301 111.012 341.301 111.012L349.129 109.03Z",
    fill: "#FF8D68"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M374.714 118.247C374.714 118.247 363.591 136.045 363.273 134.456C362.955 132.867 348.97 108.395 348.97 108.395L341.299 111.012C341.299 111.012 352.784 146.851 360.095 152.572C360.095 152.572 360.731 153.525 362.955 153.208C365.18 152.89 382.343 135.092 382.343 135.092L374.714 118.247Z",
    fill: "#FF8D68"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M385.123 97.1094C385.123 97.1094 379.164 99.4928 376.303 103.625C373.443 107.756 365.179 126.508 365.179 126.508C365.179 126.508 369.629 134.453 379.8 137.313L393.784 111.569L385.123 97.1094Z",
    fill: "#E86D5E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M377.734 158.134C377.734 158.134 378.21 165.762 378.21 168.623C378.21 168.623 366.769 223.924 366.292 236.796C365.816 249.668 375.35 275.888 375.35 275.888C375.35 275.888 416.35 274.935 429.698 272.074L431.129 244.423C431.129 244.423 433.036 196.273 431.129 182.448C429.222 168.623 421.117 161.472 421.117 161.472L418.734 154.797L377.734 158.134Z",
    fill: "#713336"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M412.774 93.7734C412.774 93.7734 423.501 98.7794 426.837 104.023C430.175 109.267 440.186 137.633 440.186 137.633C440.186 137.633 428.983 141.685 419.21 141.685C419.21 141.685 420.163 150.743 421.117 153.603C422.07 156.463 418.733 157.655 418.733 157.655C418.733 157.655 395.373 164.092 377.972 160.277C377.972 160.277 375.827 159.8 375.827 158.846C375.827 157.893 376.065 155.509 376.065 155.509C376.065 155.509 374.396 139.3 373.92 136.44C373.443 133.579 368.199 125.793 368.676 122.694C369.152 119.595 377.257 105.213 377.257 105.213C377.257 105.213 382.74 98.7778 385.123 97.1091C387.507 95.4404 393.466 95.4405 393.466 95.4405L412.774 93.7734Z",
    fill: "#E86D5E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M392.445 85.1973C392.454 85.5709 393.814 93.661 389.334 99.3868C384.852 105.237 402.528 104.988 406.636 99.0132C410.37 93.661 409.996 92.7893 409.996 92.7893C409.996 92.7893 407.009 83.0803 407.88 76.7319C407.631 71.007 392.196 74.4921 392.445 85.1973Z",
    fill: "#FF8D68"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M392.332 51.4271C392.332 51.4271 387.179 52.7463 384.259 60.6588C381.341 68.5713 383.286 85.3858 385.232 87.3641C387.178 89.3424 393.09 88.5861 401.288 85.8806C409.95 83.0214 412.877 74.0164 414.424 68.0773C417.389 56.7021 407.498 44.9982 392.332 51.4271Z",
    fill: "#FF8D68"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M382.342 60.4011C382.342 60.4011 387.109 71.8427 405.225 72.4786L409.436 92.7002C409.436 92.7002 417.149 96.4053 420.163 98.0632C420.163 98.0632 423.659 61.3541 415.396 52.4554C407.133 43.5567 392.513 45.7807 386.792 50.8664C381.072 55.9521 382.342 60.4011 382.342 60.4011Z",
    fill: "#024470"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M412.774 93.7709L408.722 89.957C408.722 89.957 405.146 100.206 392.512 100.922C392.512 100.922 390.844 98.3004 391.798 94.4865L389.652 96.1552C389.652 96.1552 385.124 102.591 385.6 104.498C386.077 106.405 392.116 103.067 392.116 103.067C392.116 103.067 399.267 107.358 402.127 107.596C404.987 107.835 412.297 94.4865 412.774 93.7709Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M405.508 72.1852C405.508 72.1852 407.419 69.033 409.33 70.1945C411.241 71.3559 408.114 78.4888 405.508 78.6549C402.901 78.8209 404.291 74.01 405.508 72.1852Z",
    fill: "#FF7759"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M409.993 114.426L417.302 140.487",
    stroke: "#BB524F",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M405.464 115.941C405.464 115.941 407.133 120.947 412.616 124.284",
    stroke: "#BB524F",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M413.807 109.737C413.807 109.737 414.76 103.062 422.388 102.586",
    stroke: "#BB524F",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M376.383 106.879C376.383 106.879 368.596 119.671 368.676 122.691C368.755 125.71 373.761 134.292 373.761 134.292L379.958 150.501",
    stroke: "#BB524F",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M403.319 160.035L411.661 150.5",
    stroke: "#BB524F",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M333.397 98.5377L323.62 95.7383C323.62 95.7383 324.497 97.9017 325.133 98.5377C325.769 99.1736 332.602 101.557 332.602 101.557",
    stroke: "#E66657",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M325.134 98.5352C325.134 98.5352 326.087 101.395 326.564 101.872C327.041 102.349 333.08 104.097 333.08 104.097",
    stroke: "#E66657",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M334.827 96.1523L337.81 98.4752L340.071 97.8999",
    stroke: "#E66657",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M393.466 87.8863C393.466 87.8863 399.505 86.6153 402.683 80.8945",
    stroke: "#E66657",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M388.222 73.9023L387.11 79.9411L389.175 80.4176",
    stroke: "#E66657",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M387.904 83.1163C387.904 83.1163 390.923 83.7523 394.101 82.0039",
    stroke: "#E66657",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M399.187 77.0022C399.187 78.626 397.871 79.9419 396.248 79.9419C394.624 79.9419 393.308 78.626 393.308 77.0022C393.308 75.3783 394.625 74.0625 396.248 74.0625C397.871 74.0625 399.187 75.3783 399.187 77.0022Z",
    fill: "#FA6157"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M393.466 73.0273C393.466 73.4224 393.146 73.7421 392.751 73.7421C392.357 73.7421 392.037 73.4216 392.037 73.0273C392.037 72.6321 392.357 72.3125 392.751 72.3125C393.146 72.3125 393.466 72.6329 393.466 73.0273Z",
    fill: "#024470"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M385.759 73.0273C385.759 73.4224 385.438 73.7421 385.044 73.7421C384.65 73.7421 384.329 73.4216 384.329 73.0273C384.329 72.6321 384.65 72.3125 385.044 72.3125C385.438 72.3125 385.759 72.6329 385.759 73.0273Z",
    fill: "#024470"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M380.673 166.946C380.673 166.946 393.783 170.998 406.179 165.754",
    stroke: "#562525",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M384.567 171.633C384.567 171.633 391.242 173.858 402.047 169.727",
    stroke: "#562525",
    strokeWidth: 1.1485,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M381.694 168.213L356.51 182.754L375.817 216.195L401.002 201.655L381.694 168.213Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M405.544 181.16C405.544 181.16 401.571 185.53 400.379 186.484C399.187 187.437 391.083 188.152 391.083 188.152C391.083 188.152 387.507 194.111 386.554 193.873C385.601 193.635 385.839 192.92 385.839 192.92C385.839 192.92 385.601 182.193 386.316 181.002C387.031 179.81 398.711 176.473 398.711 176.473L400.142 174.805L405.544 181.16Z",
    fill: "#FF8D68"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M436.69 138.73C437.008 139.684 439.55 147.153 440.822 150.967C442.093 154.78 413.489 174.804 409.04 178.299L405.544 181.159L400.141 174.803L425.249 149.695L421.594 141.431L436.69 138.73Z",
    fill: "#FF8D68"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M386.554 193.87L388.063 187.195",
    stroke: "#E66657",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M385.68 187.833L387.428 184.02",
    stroke: "#E66657",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M386.316 181L385.68 193.872H387.745L391.083 188.151",
    stroke: "#E66657",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2422 97.1367C33.2422 97.1367 26.428 97.5153 22.2638 113.036C18.0996 128.556 15.4497 147.484 16.9639 152.405C18.4782 157.327 34.7556 170.576 40.8126 170.576C46.8696 170.576 47.2482 166.033 46.1125 162.247C44.9768 158.461 33.2422 148.241 33.2422 148.241C33.2422 148.241 42.7062 117.957 42.3277 110.007C41.9483 102.058 37.4055 97.1367 33.2422 97.1367Z",
    fill: "#7E78C7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M118.563 92.5102L117.433 92.6256L119.966 87.6113C119.966 87.6113 126.404 87.2053 127.437 89.9242L124.484 96.4735L118.563 92.5102Z",
    fill: "#FF8D68"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M122.181 78.2638C122.181 78.2638 121.93 73.1391 123.754 72.411C125.577 71.683 127.619 73.1009 127.619 73.1009C127.619 73.1009 130.57 72.8004 131.512 74.0598C132.453 75.3192 132.377 77.2244 132.377 77.2244C132.377 77.2244 134.041 77.5972 134.474 79.1795C134.906 80.7618 134.134 83.8219 134.134 83.8219C134.134 83.8219 132.206 86.1871 129.978 85.601C127.749 85.0149 122.181 78.2638 122.181 78.2638Z",
    fill: "#FF7759"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M118.808 82.4016C118.808 82.4016 118.125 75.6945 118.847 74.8079C119.57 73.9213 126.96 63.6992 126.96 63.6992C126.96 63.6992 128.492 65.4401 127.61 67.4276C126.729 69.415 123.249 75.4438 123.249 75.4438L123.231 80.5959C123.231 80.5959 120.955 82.1832 118.808 82.4016Z",
    fill: "#FF7759"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M119.355 87.7667C119.355 87.7667 117.59 76.995 118.794 75.5173C119.999 74.0387 125.905 74.9013 127.033 75.328C128.16 75.7556 131.281 79.7745 131.713 81.3568C132.146 82.9391 129.205 88.6599 127.436 89.9251C125.668 91.1895 120.379 89.8313 119.355 87.7667Z",
    fill: "#FF8D68"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M115.198 94.866L117.469 90.7018C117.469 90.7018 122.769 89.7554 125.419 93.9196C126.176 95.4338 125.798 95.4338 125.798 95.4338L124.094 98.8409L115.198 94.866Z",
    fill: "#DEE0E8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2767 49.2969C61.2767 49.2969 66.8771 50.7298 70.0492 59.3288C73.2213 67.9279 71.1069 86.2002 68.9916 88.3495C66.8762 90.4989 60.4523 89.6778 51.5436 86.7373C42.131 83.6308 38.9506 73.8446 37.2686 67.3899C34.0475 55.0293 44.7959 42.3101 61.2767 49.2969Z",
    fill: "#FF8D68"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1909 96.7607L45.7337 80.4833C45.7337 80.4833 54.8192 77.8334 60.4968 83.8904L62.3896 86.5404V97.1401C62.3896 97.1401 52.9264 99.0321 41.1909 96.7607Z",
    fill: "#FF8D68"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5101 184.396C28.5101 184.396 25.103 204.27 28.5101 226.983C31.9172 249.696 38.7313 251.967 44.9768 251.967C51.2231 251.967 52.9266 233.797 54.0623 225.847C55.198 217.897 59.7408 190.642 51.2231 184.395C42.7054 178.15 33.0529 177.582 28.5101 184.396Z",
    fill: "#3D4776"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3589 211.082C52.3589 211.082 45.5448 192.912 57.4695 184.962C69.3943 177.012 78.4789 178.148 81.3182 191.208C84.1574 204.268 84.7252 249.127 80.7503 258.212C76.7754 267.297 62.5793 253.102 52.3589 211.082Z",
    fill: "#3D4776"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2041 50.0747C72.2041 50.0747 74.8914 53.5682 73.2792 57.5987C71.667 61.6292 65.7553 63.2414 65.7553 63.2414C65.7553 63.2414 67.6364 65.9287 65.7553 69.6903L64.412 71.8396C64.412 71.8396 66.2932 76.1392 65.7553 77.2142C65.2181 78.2893 63.3369 78.0203 63.3369 78.0203C63.3369 78.0203 61.1876 72.1086 60.3806 72.6457C59.5745 73.1829 57.4252 75.8702 57.4252 78.2885C57.4252 80.7068 58.2313 82.588 57.6942 84.2002C57.157 85.8124 48.827 85.8124 45.3336 85.2753C41.8402 84.7382 36.4664 73.9898 35.1223 69.1523C35.1223 69.1523 33.2411 62.4345 35.9284 56.7918C35.9284 56.7918 35.3913 51.9551 39.959 47.1185C44.5275 42.2818 59.0374 43.894 61.4557 45.7752C61.4557 45.7752 61.1867 43.0879 63.8741 43.6259C66.5614 44.163 70.5919 46.5813 72.2041 50.0747Z",
    fill: "#C53A45"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1433 74.5289C64.1433 74.5289 63.3372 71.0355 60.3809 72.6477C57.4254 74.2599 60.918 82.59 63.3372 82.0529C65.7555 81.5149 64.6804 75.8721 64.1433 74.5289Z",
    fill: "#FF7759"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7878 96.6746C38.7878 96.6746 40.0555 92.2182 41.1912 91.8397C42.3269 91.4611 56.3329 89.9468 63.9042 94.4896C67.3113 97.1395 66.9327 99.0323 66.9327 99.0323C66.9327 99.0323 44.3335 94.6955 38.7878 96.6746Z",
    fill: "#DEE0E8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8913 95.6249C35.8913 95.6249 59.3614 94.1106 76.0182 101.303C83.5894 105.089 100.908 122.218 100.908 122.218L114.535 93.8267C114.535 93.8267 122.201 91.0821 125.23 98.2748C125.23 98.2748 116.617 131.777 109.426 142.376C104.883 146.161 83.2108 133.858 83.2108 133.858C83.2108 133.858 86.6179 177.77 85.4822 197.455C83.968 201.241 54.4409 203.134 49.141 202.755C43.8411 202.376 25.2923 196.319 24.9138 195.184C24.5352 194.048 27.5637 148.622 26.8066 143.322C26.0495 138.022 23.7781 111.902 24.5352 108.117C25.2923 104.332 28.6994 97.1391 35.8913 95.6249Z",
    fill: "#7E78C7"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0872 206.824C50.0872 206.824 58.037 232.376 63.9985 244.869",
    stroke: "#2A2E59",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M71.854 205.408C71.854 205.408 78.2896 209.194 80.9395 203.137",
    stroke: "#2A2E59",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2893 206.16C78.2893 206.16 81.3178 229.63 80.5607 245.151",
    stroke: "#2A2E59",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5352 117.961L27.5637 150.516",
    stroke: "#524B81",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4912 129.316C76.4912 129.316 98.9203 145.499 109.425 142.377",
    stroke: "#524B81",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M103.179 125.34C103.179 125.34 107.722 127.895 107.438 133.858",
    stroke: "#524B81",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M102.043 123.07C102.043 123.07 106.87 121.65 109.709 126.477",
    stroke: "#524B81",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6397 103.48C75.6397 103.48 63.7158 109.727 71.6648 124.206",
    stroke: "#524B81",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7471 84.6016C58.7471 84.6016 60.7345 89.7122 67.4067 88.8604",
    stroke: "#E66657",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M123.005 74.0968L125.229 72.1094C125.229 72.1094 126.79 72.1011 127.619 73.099",
    stroke: "#E66657",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M125.656 74.4236C125.656 74.2817 128.826 72.5781 128.826 72.5781C128.826 72.5781 131.713 73.2879 132.139 74.8022C132.565 76.3164 132.233 77.1209 132.233 77.1209",
    stroke: "#E66657",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M129.394 77.1703C129.536 77.123 133.416 77.3596 133.416 77.3596C133.416 77.3596 134.836 78.306 134.788 80.1515C134.741 81.997 134.133 83.8176 134.133 83.8176C134.133 83.8176 132.754 85.7818 130.388 85.7345",
    stroke: "#E66657",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M131.618 81.1484C131.618 81.1484 132.091 81.9056 131.476 83.2779C130.861 84.6502 130.116 88.244 127.437 89.9251",
    stroke: "#E66657",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0808 56.4906C45.5443 53.7934 38.4463 57.0585 38.4463 57.0585C38.4463 57.0585 39.2981 53.3675 43.273 52.0898",
    stroke: "#A03A45",
    strokeWidth: 1.368,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7302 59.3293C38.7302 59.3293 40.1498 59.1873 41.9953 62.0266",
    stroke: "#A03A45",
    strokeWidth: 1.368,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1467 46.5977C63.1467 46.5977 70.1502 47.7333 70.3394 54.7368",
    stroke: "#A03A45",
    strokeWidth: 1.368,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealjob);
export default __webpack_public_path__ + "static/media/realjob.f27d653da4315758320fcddf95f1e42f.svg";
export { ForwardRef as ReactComponent };